// Utility function to update the web app manifest based on theme
export function updateManifest(isDark: boolean) {
  const manifest = {
    short_name: "Kestrel AI",
    name: "Kestrel AI - AI Agents for Platform Engineering",
    icons: [
      {
        src: isDark ? "Logo_Kestrel AI_dark_mode.svg" : "Logo_Kestrel AI_light_mode.svg",
        sizes: "any",
        type: "image/svg+xml"
      },
      {
        src: isDark ? "Logo_Kestrel AI_dark_mode.svg" : "Logo_Kestrel AI_light_mode.svg",
        type: "image/svg+xml",
        sizes: "any"
      },
      {
        src: isDark ? "Logo_Kestrel AI_dark_mode.svg" : "Logo_Kestrel AI_light_mode.svg",
        type: "image/svg+xml",
        sizes: "any"
      }
    ],
    start_url: ".",
    display: "standalone",
    theme_color: isDark ? "#0a0a0a" : "#ffffff",
    background_color: isDark ? "#0a0a0a" : "#ffffff"
  };

  // Update the manifest link
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    // Create a new blob with the updated manifest
    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    manifestLink.setAttribute('href', url);
  }
} 